<template>
	<div style="height: 100vh;overflow:auto;">
		<div v-if="/pdf/i.test(selectedFile.extension)" class="pdfWrapper">
			<pdfViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/xl/gi.test(selectedFile.extension)" class="xlsxWrapper">
			<xlsxViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/txt/gi.test(selectedFile.extension)" class="txtWrapper">
			<txtViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/csv/gi.test(selectedFile.extension)" class="csvWrapper">
			<csvViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/htm/gi.test(selectedFile.extension)" class="htmlWrapper">
			<htmlViewer :selectedFile="selectedFile" />
		</div>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn
					v-on="on"
					color="green darken-1"
					small
					absolute
					top
					right
					fab
					@click="downloadOriginalSystemFile"
				>
					<v-icon color="white">get_app</v-icon>
				</v-btn>
			</template>
			<span>Download Current File</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn
					v-on="on"
					color="orange darken-1"
					small
					absolute
					top
					left
					fab
					@click="downloadOriginalFile"
				>
					<v-icon color="white">get_app</v-icon>
				</v-btn>
			</template>
			<span>Download Original File</span>
		</v-tooltip>
	</div>
</template>

<script>
import pdfViewer from '../../components/pdfViewer';
import xlsxViewer from '../../components/xlsxViewer';
import txtViewer from '../../components/textViewer';
import csvViewer from '../../components/csvViewer';
import htmlViewer from '../../components/htmlViewer';
import { mapGetters, mapActions } from 'vuex';
export default {
	created() {},
	components: {
		pdfViewer,
		xlsxViewer,
		txtViewer,
		csvViewer,
		htmlViewer,
	},
	data() {
		return {};
	},
	methods: {
		// ...mapMutations("reworkExtractedData", ["closeFileMetaDialog"]),
		...mapActions('reworkExtractedData', [
			'downloadFile',
			'downloadActualFile',
		]),
		downloadOriginalSystemFile() {
			this.downloadFile().then();
		},
		downloadOriginalFile() {
			this.downloadActualFile().then();
		},
	},
	computed: {
		...mapGetters('reworkExtractedData', ['selectedFile']),
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.pdfWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
// .xlsxWrapper {
// 	display: flex;
// 	flex-direction: column;
// 	width: 100%;
// 	align-items: center;
// }
.txtWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.csvWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.htmlWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
</style>
